import * as mutationTypes from './types/mutation_types';

import initialState from './initialState';

export default {
  [mutationTypes.CAT_ING_REQUEST](state) {
    Object.assign(state, { loading: true, error: null });
  },
  [mutationTypes.CAT_ING_SUCCESS](state, payload) {
    Object.assign(state, { loading: false, data: payload });
  },
  [mutationTypes.CAT_ING_ERROR](state, payload) {
    Object.assign(state, {
      loading: false,
      data: null,
      error: payload || true,
    });
  },
  [mutationTypes.CAT_ING_RESET](state) {
    Object.assign(state, ...initialState);
  },
  [mutationTypes.CAT_ING_SELECT](state, payload) {
    Object.assign(state, { selected: payload });
  },
  [mutationTypes.CAT_ING_SELECT_RESET](state) {
    Object.assign(state, { selected: { title: '' } });
  },
};
